import { transform } from "framer-motion"
import { dsktpExitTiming } from "./variables"
import { extVideoEndPoint } from "../loader/variables"

export const numberVariants = {
    initial: {
        transform: "translate3d(-100%, 100%, 0)"
    }, animate:{
        transform: "translate3d(-100%, 0%, 0)",
        transition:{
            duration: .35
        }
    }, exit: {
        transform: "translate3d(-100%, -100%, 0)"
    }
}

export const mobArtistVariants ={
    initial: {
        transform: "translate3d(0, 50%, 0)"
    }, animate: (i) => ({
        transform: "translate3d(0, -50%, 0)",
        transition:{
            duration: .95 + 0.15*i
        }
    }), exit: {
        transform: "translate3d(0, -150%, 0)"
    }
}

export const auxProjNumVariants = {
    initial: (i) => ({
        transform: "translate3d(0, 100%, 0)"
    }), animate: (i) => ({
        transform: "translate3d(0, 0%, 0)",
        transition: {
            duration: i[1] ? 2 : 1.5,
            delay: i[1] ? (extVideoEndPoint - 0.5) + i[0] * 0.1: i[0]*0.05,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        transition: {
            duration: dsktpExitTiming,
            delay: i[0] * 0.05,
            ease: [0.85, 0, 0.15, 1]
        }
    }),
    projExit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        transition: {
            duration: dsktpExitTiming,
            delay: i[0] * 0.05,
            ease: [0.85, 0, 0.15, 1]
        }
    })
}

export const artistVariants = {
    initial: {
        transform: "translate3d(0, 100%, 0)"
    }, animate: (i) => ({
        transform: ["translate3d(0, 100%, 0)", "translate3d(0, 0%, 0)"],
        transition:{
            duration: i[1] ? 2 : 1.5,
            delay: i[1] ? (extVideoEndPoint - 0.5) + i[0]*0.1 : i[0]*0.05,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i) => ({
        transform: "translate3d(0, -100%, 0)",
        transition: {
            duration: 0.25,
            delay: i[0]*0.05,
            ease: [0.85, 0, 0.15, 1]
        }
    }), projExit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        transition: {
            duration: dsktpExitTiming,
            delay: i[0] * 0.05,
            ease: [0.85, 0, 0.15, 1]
        }
    })
}

export const projectTileVariants = {
    wide:{
        height: "20dvh",
        transform: "translate3d(0, 0, 0)",
        transition: {
            duration: 1,
            ease: [0.33, 1, 0.68, 1]
        }
    },
    square: (i) => ({
        height: "33.33dvh",
        transform: "translate3d(0, calc((-" + (i - 1) + "* 33.33333vh) + ("+ (i-2) +" * 20vh)), 0)",
        transition: {
            duration: 1.5,
            ease: [0.33, 1, 0.68, 1]
        }
    })
}

export const filterOptionsWrapperVariants={
    initial:{

    },animate:{
        transition: {
            staggerChildren: 1
        }

    },exit:{
        transition: {
            staggerChildren: 0.15
        }
    }
}

export const filterOptionsVariants={
    initial:{
        opacity: 0,
    },animate:{
        opacity: 1,
    },exit:{
        opacity: 0,
        transition: {
            duration: 0.35
        }
    }
}

export const upDownVariants = {
    initial: (i) => ({
        transform: "translate3d(0, 100%, 0)"
    }), animate: (i) => ({
        transform: "translate3d(0, 0%, 0)",
        transition: {
            duration: 1.5,
            delay: i*0.05,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        transition: {
            duration: dsktpExitTiming,
            delay: i * 0.05,
            ease: [0.85, 0, 0.15, 1]
        }
    }),
    projExit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        transition: {
            duration: dsktpExitTiming,
            delay: i * 0.05,
            ease: [0.85, 0, 0.15, 1]
        }
    })
}

export const boxToggleVariants = {
    initial: (i) => ({
        transform: "translate3d(0, 0, 0)"
    }), animate: (i) => ({
        transform: "translate3d(0, 0%, 0)",
        transition: {
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i) => ({
        transform: "translate3d(100%, 0, 0)",
        transition: {
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
        }
    })
}

export const scrollIndVariants = {
    initial: {
        opacity: 0
    }, animate: {
        opacity: 1,
        transition: {
            duration: 1
        }
    }, exit: {
        opacity: 0,
        transition: {
            duration: 1
        }
    }
}

export const DTHeroVariants = {
    initial: (i) => ({
        transform: "translate3d(0, -100%, 0)",
        opacity: 0
    }), animate: (i) => ({
        opacity: 1,
        transform: "translate3d(0, 0%, 0)",
        transition: {
            duration: 1,
            delay: !i[3] ? i[0] * 0.025 : extVideoEndPoint-0.5,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i) => ({
        opacity: 0,
        transform: !i[2] ? "translate3d(0, 100%, 0)" : "translate3d(0, -100%, 0)",
        transition: {
            duration: !i[2] ? dsktpExitTiming : 0.5,
            opacity: {
                duration: i[1] ? dsktpExitTiming : dsktpExitTiming,
            },
            delay: i[0] * 0.025,
            ease: ![2] ? [0.7, 0, 0.84, 0] : [0.85, 0, 0.15, 1]
        }
    })
}

export const DTSubHeroVariants = {
    initial: (i) => ({
        transform: `translate3d(0, 100%, 0) scale3d(1, ${i[4]}, 1)`,
        opacity: 0
    }), animate: (i) => ({
        opacity: 1,
        transform: `translate3d(0, 0%, 0) scale3d(1, ${i[4]}, 1)`,
        transition: {
            duration: 1.5,
            delay: !i[3] ? 0.1 + i[0] * 0.01 : extVideoEndPoint-0.5,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i) => ({
        opacity: 0,
        transform: `translate3d(0, 100%, 0) scale3d(1, ${i[4]}, 1)`,
        transition: {
            duration: !i[2] ? dsktpExitTiming : 0.5,
            opacity: {
                duration: dsktpExitTiming,
            },
            delay: i[0] * 0.005,
            ease: [0.87, 0, 0.13, 1]
        }
    })
}

export const DTSecondaryHeroVariants = {
    initial: {
        opacity: 0
    }, animate: (i) => ({
        opacity: 1,
        transition: {
            duration: 1,
            delay: !i[1] ? 0.45 : extVideoEndPoint-0.5,
            ease: [0.65, 0, 0.35, 1]
        }
    }), exit: (i) => ({
        opacity: 0,
        transition: {
            duration: !i[0] ? dsktpExitTiming : 0.5,
            ease: [0.16, 1, 0.3, 1]
        }
    })
}

export const hptVariants = {
    initial: {
        transform: "translate3d(0, 0, 0) rotate(0.002deg) scale3d(1,1,1)"
    }, animate: {
        transform: "translate3d(0, 0, 0) rotate(0.002deg) scale3d(1,1,1)",
    }, exit: (i) => ({
        transform: "translate3d(0, 0, 0) rotate(0.002deg) scale3d(1,1,1)",
        opacity: 0,
        transition: {
            delay: 0.05 * i[1],
            duration: 0.45,
        }
    }), 
    notSelectedProjExit: (i) => ({
        opacity: 0,
        transition: {
            duration: 0.5
        }
    }),
    projExit: (i) => ({
        transform: `translate3d(0, ${-1 * i[0]*(window.innerHeight/5)}px, 0) rotate(0.002deg) scale3d(1,1,1)`,
        // width: (window.innerWidth - (getGutterWidth(window.innerWidth).main *2))+"px",
        // height: Math.min((window.innerWidth - (getGutterWidth(window.innerWidth).main *2)) * (9/16), window.innerHeight - 180) + "px",
        display: "none",
        transition: {
            duration: 1,
            delay: 0,
            ease: [0.16, 1, 0.3, 1],
            display: {
                duration: 1,
                delay: 1.5
            }
        }
    })
}

export const viewChangeVariants = {
    initial: (i) => ({
        transform: 
            i[0] ? "translate3d(25.5px, -5px,0) scale(calc(13/16),calc(14/16))" 
                : i[1] ? "translate3d(25.5px, 0px,0) scale(calc(13/16),calc(14/16))" 
                    : "translate3d(25.5px, 5.5px,0) scale(calc(13/16),calc(14/16))"
    }), colMode: (i) => ({
        transform: i[0] ? "translate3d(5.5px, -5px,0) scale(calc(13/16),calc(14/16))" 
            : i[1] ? "translate3d(5.5px, 0px,0) scale(calc(13/16),calc(14/16))" 
                : "translate3d(5.5px, 5.5px,0) scale(calc(13/16),calc(14/16))",
        transition: {
            delay: i[3] ? extVideoEndPoint -0.5 : i[0] ? 0 : i[1] ? 0.075 : 0.15,
            duration: 2,
            ease: [0.16, 1, 0.3, 1]
        }
    }), gridMode: (i) => ({
        transform: i[0] ? "translate3d(9px,0,0) scale(calc(14/16),calc(10/16))" 
            : i[1] ? "translate3d(0,0,0) scale(calc(14/16),calc(10/16))" 
                : "translate3d(13px,0,0) scale(calc(12/16),calc(10/16))",
        transition: {
            delay: i[0] ? 0 : i[1] ? 0.075 : 0.15,
            duration: 2,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i) => ({
        transform: i[0] ? "translate3d(25.5px, -5px,0) scale(calc(13/16),calc(14/16))" : i[1] ? "translate3d(25.5px, 0px,0) scale(calc(13/16),calc(14/16))" : "translate3d(25.5px, 5.5px,0) scale(calc(13/16),calc(14/16))",
        transition: {
            delay: i[0] ? 0 : i[1] ? 0.075 : 0.15,
            duration: dsktpExitTiming-0.1,
            ease: [0.87, 0, 0.13, 1]
        }
    })
}

export const scrollLineWrapperVariants = {
    initial: {
        transform: "translate3d(-40px, -50%, 0)",
        opacity: 0
    }, animate: (i) => ({
        transform: "translate3d(0, -50%, 0)",
        opacity: 1,
        transition: {
            duration: i ? 2 : 1,
            delay: i ? extVideoEndPoint -0.5 : 0.25,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: {
        transform: "translate3d(-40px, -50%, 0)",
        opacity: 0,
        transition: {
            duration: dsktpExitTiming,
            ease: [0.87, 0, 0.13, 1]
        }
    }, projExit: {
        transform: "translate3d(-40px, -50%, 0)",
        opacity: 0,
        transition: {
            duration: dsktpExitTiming,
            ease: [0.87, 0, 0.13, 1]
        }
    }
}


export const filmModeVariants = {
    initial:{
        transform: "translate3d(0,100%,0)",
        transition: {
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
        }
    }, animate: (i) => ({
        transform: "translate3d(0,0%,0)",
        transition: {
            duration: i ? 2 :1.5,
            delay: i ? extVideoEndPoint - 0.5 : 0.5,
            ease: i ? [0.16, 1, 0.3, 1] : [0.16, 1, 0.3, 1]
        }
    }), exit: {
        transform: "translate3d(0,100%,0)",
        transition: {
            duration: dsktpExitTiming,
            ease: [0.85, 0, 0.15, 1]
        }
    }, projExit: {
        transform: "translate3d(0,100%,0)",
        transition: {
            duration: dsktpExitTiming,
            ease: [0.85, 0, 0.15, 1]
        }
    }
}